"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = applyDimension;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _Chart = require("../component/Chart");

function applyDimension(dimension, props) {
  return (0, _objectSpread2.default)({}, dimension, {
    columnName: props[dimension.columnKey],
    scaleName: props[dimension.scaleKey],
    scaleTypeName: props[dimension.scaleTypeKey],
    scaleUpdate: props[dimension.scaleUpdateKey]
  });
}